<template>
  <!--文章封面列表-->
  <div v-for="(item, index) in dataList" :Key="index" class="news-block-five col-md-4 col-sm-12">
    <div class="inner-box wow fadeInUp animated" @click="link_to(item)">
      <div class="image-box">
        <figure class="image"><img alt="" :src="item.imgUrl" /></figure>
        <div class="date">
          <span>{{ item.time }}</span>
        </div>
        <!--                <div class="hover-box">-->
        <!--                    <div class="more-link">-->
        <!--                        <router-link :to="item.path">Read More</router-link>-->
        <!--                    </div>-->
        <!--                </div>-->
      </div>
      <div class="lower-box">
        <div class="upper-info">
          <h4>
            <!-- {{ item.title }} -->
                                   <router-link :to="item.path">{{item.title}}</router-link>
          </h4>
          <div class="cat-info">
            <a href="#"><span class="fa fa-folder"></span>{{ item.type }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['dataList'],
  name: '',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {
    link_to(row) {
      if (row.detailtype == 'about') {
        this.$router.push({ path: '/aboutdetails/' + row.id })
      }else if (row.detailtype == 'news') {
        this.$router.push({ path: '/newsdetails/' + row.id })
      }else if (row.detailtype == 'Recruitment') {
        this.$router.push({ path: '/details/' + row.id })
      }
    },
  },
}
</script>
<style scoped lang="scss"></style>
